// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3hsdD","content":"styles_content__2Lgkn","selectAll":"styles_selectAll__6MPlE"};